import { getImageFromPage } from '~core';
import { getMetadata } from '~loader/loader-utils';
import slugify from 'slugify';
import { jsPDF } from 'jspdf';
import { getSelectedPagesByUser } from '../../getSelectedPagesByUser';
import { addWatermark } from '~src/utils';
import { getUser } from '~src/user';
import { getGridParameters } from '~core/grigliaProvino';

export default async function generateGrid() {
  const metadata = getMetadata();
  const selectedPagesByUser = getSelectedPagesByUser();

  const { user } = await getUser();

  const gridParameters = getGridParameters();

  const pdfGrid = new jsPDF(gridParameters.pdf.orientation, 'mm', [
    gridParameters.pdf.width,
    gridParameters.pdf.height,
  ]);

  let pageNumber = 0;

  for (let page of selectedPagesByUser) {
    pageNumber++;
    if (pageNumber > 1) {
      pdfGrid.addPage();
    }

    let image = await getImageFromPage(page);
    if (user.org_pointer.tipo_istanza === 'demo') {
      image = await addWatermark(image);
    }

    pdfGrid.addImage(
      image,
      'JPEG',
      0,
      0,
      gridParameters.format.width,
      gridParameters.format.height
    );

    pdfGrid.addImage(
      image,
      'JPEG',
      gridParameters.pdf.width - gridParameters.format.width,
      0,
      gridParameters.format.width,
      gridParameters.format.height
    );
  }

  const fileName = slugify(
    `Provino-${metadata.projectTypeName}${
      metadata.templatesCategoryName ? `-${metadata.templatesCategoryName}` : ''
    }${metadata.servizioName ? `-${metadata.servizioName}` : ''}${
      metadata.formatName ? `-${metadata.formatName}` : ''
    }.pdf`
  );

  return { pdfGrid, fileName };
}
